import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import i18n from "./i18n/config"; // eslint-disable-line no-unused-vars
import App from "./App";
import { store } from "./store/configureStore";
import { restoreSession } from "./store/actions/authActions";

store.dispatch(restoreSession());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);
